export const VIDEO_PIN = '232726'; // Change this to your desired PIN